import React from 'react';
import { COLORS } from '../../../../core/constants/colors';
import { AdminSubscriptionPlan } from '../types/billing.types';

interface DeletePlanModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  plan: AdminSubscriptionPlan | null;
  isLoading?: boolean;
}

export const DeletePlanModal: React.FC<DeletePlanModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  plan,
  isLoading = false,
}) => {
  if (!isOpen || !plan) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-xl max-w-md w-full">
        <div className="px-6 py-4 border-b flex items-center justify-between" style={{ borderColor: COLORS.extended.cultured }}>
          <h2 className="text-xl font-bold" style={{ color: COLORS.primary.persianIndigo }}>
            Delete Plan
          </h2>
          <button
            onClick={onClose}
            className="p-2 rounded-lg hover:bg-gray-100 transition-all"
            style={{ color: COLORS.primary.persianIndigo }}
            disabled={isLoading}
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div className="p-6">
          <div className="flex items-center justify-center w-16 h-16 rounded-full mx-auto mb-4" style={{ backgroundColor: '#FFEBEE' }}>
            <svg
              className="w-8 h-8"
              style={{ color: COLORS.extended.redSalsa }}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>

          <p className="text-center text-gray-700 mb-2">
            Are you sure you want to delete this plan?
          </p>
          <p className="text-center font-semibold mb-4" style={{ color: COLORS.primary.persianIndigo }}>
            {plan.name}
          </p>
          <p className="text-center text-sm text-gray-600 mb-6">
            This action cannot be undone. All existing subscriptions will remain active, but new users won't be able to subscribe to this plan.
          </p>

          <div className="flex gap-4">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 px-4 py-3 rounded-lg border font-semibold transition-all hover:bg-gray-50"
              style={{ borderColor: COLORS.extended.cultured, color: COLORS.primary.persianIndigo }}
              disabled={isLoading}
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={async () => {
                try {
                  await onConfirm();
                  onClose();
                } catch (error) {
                  // Error handled by parent
                }
              }}
              className="flex-1 px-4 py-3 rounded-lg font-semibold text-white transition-all disabled:opacity-50 disabled:cursor-not-allowed"
              style={{ backgroundColor: COLORS.extended.redSalsa }}
              disabled={isLoading}
            >
              {isLoading ? 'Deleting...' : 'Delete Plan'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
